import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker, AutoComplete, Input } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import VendaItemForm from './VendaItemForm';
import ItemFotoProduto from './ItemFotoProduto';
import TituloParcelaForm from './TituloParcelaForm';
import NotaFiscalEmissaoComplForm from './NotaFiscalEmissaoComplForm';
import ModalPadraoForm from './ModalPadraoForm';
import SpinnerForm from './SpinnerForm';
import { getUsuario } from "../utils/LoginManager";
import Colors from '../utils/Colors';

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;

export const OPCOES_COMBO_SIT = [
  { key: 'ESP', label: 'ESPERA' },
  { key: 'AGE', label: 'AGENDAMENTO' },
  { key: 'EXE', label: 'EXECUÇÃO' },
  { key: 'FIN', label: 'FINALIZADA' },
  { key: 'ENT', label: 'ENTREGUE' },
]


export default class OrdemServicoForm extends Component {
  state = {
    registro: {
      os_idf: 0,
      os_numero: '',
      os_situacao: { key: 'EXE' },
      os_vlr_total: 0,
      os_cliente: { key: '0' },
      os_data_emissao: moment().format('DD/MM/YYYY'),
      os_data_ini: moment().format('DD/MM/YYYY'),
      os_data_fim: moment().format('DD/MM/YYYY'),
      os_usuario: { key: '0' },
      os_descricao: '',
      os_solicitante: '',
      os_tipo_doc: { key: '0' },
      os_cond_pagto: { key: '0' },
      oso_defeitos: '',
      oso_laudo: '',
      os_veiculo: 0,
      os_emitir_nfe: 0,
      os_emitir_nfse: 0,
      veic_descricao: '',
      checkListSelect: [],
      listaCheckList: [],
    },

    registroNfe: {},

    modalEmissaoNFeVisible: false,
    modalProdutoVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,
    caixaFechado: false,

    activeKey: "dados",

    listaProdutos: [],
    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,

    codVeiculosSelect: [],
    descVeiculosSelect: [],
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      let caixaFechado = false;
      if (this.props.registroSelecionado.listaParcelas) {
        for (var x in this.props.registroSelecionado.listaParcelas) {
          if (this.props.registroSelecionado.listaParcelas[x].cx_situacao === 0) {
            caixaFechado = true;
          }
        };
      }

      this.setState({
        registro: this.props.registroSelecionado.dados,
        os_cliente: this.props.registroSelecionado.dados.os_cliente,
        os_usuario: this.props.registroSelecionado.dados.os_usuario,
        os_tipo_doc: this.props.registroSelecionado.dados.os_tipo_doc,
        os_cond_pagto: this.props.registroSelecionado.dados.os_cond_pagto,
        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        listaCheckList: this.props.registroSelecionado.listaCheckList ? this.props.registroSelecionado.listaCheckList : [],
        caixaFechado,
        visualizando: this.props.registroSelecionado.dados.visualizando,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : []);
      });

      if (this.state.usuario.par_checklist_completo) {
        if (!this.props.registroSelecionado.listaCheckList) {
          this.buscaCheckListCompleta();
        }
      } else {
        this.buscaCheckList();
      }

      if (this.props.registroSelecionado.dados.os_idf) {
        if (this.state.usuario.par_cliente != this.props.registroSelecionado.dados.os_cliente) {
          this.buscaVeiculos(this.props.registroSelecionado.dados.os_cliente.key);
        }
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
    this.buscaCheckList();
  }


  onOK = () => {
    if ((!this.state.registro.os_data_emissao) || (!moment(this.state.registro.os_data_emissao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.os_cliente) || (this.state.registro.os_cliente.key === '0') || (this.state.registro.os_cliente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.registro.os_usuario) || (this.state.registro.os_usuario.key === '0') || (this.state.registro.os_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }
    if ((!this.state.registro.os_descricao) || (this.state.registro.os_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição da O.S' });
      return;
    }

    if ((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) {
      let vlrTotalParc = 0
      for (var x in this.state.listaParcelas) {
        vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
      };
      let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.os_vlr_total)).toFixed(2));
      if (vlrDifParc !== 0) {
        Modal.warning({ title: 'Aviso!', content: 'O Valor Total da O.S não Confere com o Valor Total das parcelas' });
        return;
      }
    }

    if (this.state.registro.os_emitir_nfe) {
      let qtde = 0;
      for (var x in this.state.listaProdutos) {
        if (this.state.listaProdutos[x].tipoItem === 'P') {
          qtde++;
        }
      };
      if (qtde === 0) {
        Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na lista' });
        return;
      }
      Modal.confirm({
        title: 'Confirmação de Emissão',
        content: `Deseja Emitir Nota de Produto(NFe) desta O.S?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => { this.onAbrirModalEmissaoNFeClick() }
      })
    } else if (this.state.registro.os_emitir_nfse) {
      let qtde = 0;
      for (var x in this.state.listaProdutos) {
        if (this.state.listaProdutos[x].tipoItem === 'S') {
          qtde++;
        }
      };
      if (qtde === 0) {
        Modal.warning({ title: 'Aviso!', content: 'Inclua algum serviço na lista' });
        return;
      }
      Modal.confirm({
        title: 'Confirmação de Emissão',
        content: `Deseja Emitir Nota de Serviço(NFSe) desta O.S?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => {
          this.onSalvar({
            nf_idf: this.state.registro.nf_idf_nfse ? this.state.registro.nf_idf_nfse : 0,
            nf_numero: this.state.registro.nf_numero_nfse ? this.state.registro.nf_numero_nfse : 0,
            nf_emitente: 0,
            transmitir: true,
          })
        }
      })
    } else {
      this.onSalvar();
    }
  };


  onSalvar = (reg) => {

    // console.log('OrdemServicoForm.onSalvar', reg)
    // return;

    const registro = {
      os_idf: this.state.registro.os_idf,
      os_numero: this.state.registro.os_numero ? this.state.registro.os_numero : '0',
      os_vlr_total: this.state.registro.os_vlr_total,
      os_situacao: this.state.registro.os_situacao.key,
      os_data_emissao: moment(this.state.registro.os_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      os_data_ini: moment(this.state.registro.os_data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      os_data_fim: moment(this.state.registro.os_data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      os_cliente: this.state.registro.os_cliente.key,
      pes_nome: this.state.registro.os_cliente.label,
      os_usuario: this.state.registro.os_usuario.key,
      os_descricao: this.state.registro.os_descricao,
      os_solicitante: this.state.registro.os_solicitante,

      os_cond_pagto: this.state.registro.os_cond_pagto.key,

      oso_defeitos: this.state.registro.oso_defeitos,
      oso_laudo: this.state.registro.oso_laudo,

      os_veiculo: this.state.registro.os_veiculo,
      veic_descricao: this.state.registro.veic_descricao,

      listaProdutos: this.state.listaProdutos,
      listaParcelas: this.state.listaParcelas,
      checkListSelect: this.state.registro.checkListSelect,
      listaCheckList: this.state.listaCheckList,

      os_emitir_nfe: this.state.registro.os_emitir_nfe ? this.state.registro.os_emitir_nfe : '0',
      os_emitir_nfse: this.state.registro.os_emitir_nfse ? this.state.registro.os_emitir_nfse : '0',
      registroNfe: reg,
    };


    this.props.onSalvarClick(registro);
  }


  // ----------------------------------------------------------------
  // EMISSÃO NFE
  // ----------------------------------------------------------------

  onAbrirModalEmissaoNFeClick = () => {
    // console.log('onAbrirModalEmissaoNFeClick', this.state.registro);

    if (this.state.registro.nf_idf_nfe) {

      this.setState({ carregando: true });
      axios.get(`/notas_fiscais/show/${this.state.registro.nf_idf_nfe}`)
        .then(response => {
          const { data } = response;

          data.dados.nf_tipo = 'OS';
          data.dados.nf_dt_inclusao = moment(data.dados.nf_dt_inclusao, 'YYYY-MM-DD').format('DD/MM/YYYY');
          data.dados.nf_dt_emissao = moment(data.dados.nf_dt_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');

          data.dados.nf_destinatario = {
            key: String(this.state.registro.os_cliente.key),
            label: this.state.registro.os_cliente.label,
          };

          data.dados.nf_tipo_mov_nf = { key: String(data.dados.nf_tipo_mov_nf), label: '', };
          data.dados.nf_emitente = { key: String(data.dados.nf_emitente), label: '', };
          data.dados.nf_modelo = { key: String(data.dados.nf_modelo), label: '', };
          data.dados.nf_nat_oper = { key: String(data.dados.nf_nat_oper), label: '', };
          data.dados.nf_forma_pagamento = { key: String(data.dados.nf_forma_pagamento), label: '', };
          data.dados.nf_finalidade_emissao = { key: String(data.dados.nf_finalidade_emissao), label: '', };
          data.dados.nf_consumidor_final = { key: String(data.dados.nf_consumidor_final), label: '', };
          data.dados.nf_tipo_documento = { key: String(data.dados.nf_tipo_documento), label: '', };
          data.dados.nf_tipo_atendimento = { key: String(data.dados.nf_tipo_atendimento), label: '', };
          data.dados.nff_tipo = { key: String(data.dados.nff_tipo), label: '', };
          data.dados.nff_idf_transportadora = { key: data.dados.nff_idf_transportadora ? String(data.dados.nff_idf_transportadora) : '0', label: '', };

          data.dados.nf_cond_pagto = {
            key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tit_cond_pagto) ? String(data.listaParcelas[0].tit_cond_pagto) : '',
            label: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_descricao) ? String(data.listaParcelas[0].cp_descricao) : '',
            qtdeParc: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_qtde_parc) ? String(data.listaParcelas[0].cp_qtde_parc) : '',
            parcAVista: (data.listaParcelas.length > 0 && data.listaParcelas[0].cp_parc_avista) ? String(data.listaParcelas[0].cp_parc_avista) : '',
          }

          data.dados.nf_tipo_doc = {
            key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tparc_tipo_doc) ? String(data.listaParcelas[0].tparc_tipo_doc) : '',
            label: (data.listaParcelas.length > 0 && data.listaParcelas[0].td_descricao) ? String(data.listaParcelas[0].td_descricao) : '',
          }

          data.dados.visualizando = false;

          this.setState({
            modalEmissaoNFeVisible: true,
            registroNfe: {
              registro: data,
              registroVenda: this.state.registro,
              listaProdutosNF: data.listaProdutos,
              listaProdutosVenda: this.state.listaProdutos
            },
            carregando: false,
          })
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            carregando: false,
          })
        })
    } else {

      var listaProdutos = [];
      for (var x in this.state.listaProdutos) {
        if (this.state.listaProdutos[x].tipoItem === 'P') {
          listaProdutos.push(this.state.listaProdutos[x]);
        }
      };

      this.setState({
        modalEmissaoNFeVisible: true,
        registroNfe: {
          registro: {
            dados: {
              nf_destinatario: {
                key: String(this.state.registro.os_cliente.key),
                label: this.state.registro.os_cliente.label,
              },
              nf_idf: 0,
              nf_tipo: 'OS',
              nf_numero: '0',
              nf_serie: '0',
              situacao_nota: 'Nova NFe',
              nf_dt_inclusao: moment().format('DD/MM/YYYY'),
              nf_dt_emissao: moment().format('DD/MM/YYYY'),
              nf_forma_pagamento: { key: '2', label: '', },
              nf_finalidade_emissao: { key: '1', label: '', },
              nf_consumidor_final: { key: '1', label: '', },
              nf_tipo_documento: { key: '1', label: '', },
              nf_tipo_atendimento: { key: '1', label: '', },
              nff_tipo: { key: '9', label: '', },

              nff_idf_transportadora: { key: '0', label: '', },
              nff_especie: 0,
              nff_marca: 0,
              nff_num_volumes: 0,
              nff_peso_bruto: 0,
              nff_peso_liquido: 0,
              nff_qtde_vol: 0,

            }
          },
          registroVenda: this.state.registro,
          listaProdutosNF: [],
          listaProdutosVenda: listaProdutos
        },
        carregando: false,
      })
    }
  }

  onFecharModalEmissaoNFeClick = () => {
    this.setState({
      modalEmissaoNFeVisible: false,
    });
  }

  onSalvarEmissaoNfeClick = (registroNfe) => {
    this.setState({
      modalEmissaoNFeVisible: false,
    },
      this.onSalvar(registroNfe)
    );
  }

  // ----------------------------------------------------------------




  calculoTotalPedido = (listaProdutos) => {
    const { registro } = this.state;
    let vlrServicos = 0;
    let vlrProdutos = 0;
    let vlrAvulsos = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);

      if (listaProdutos[x].tipoItem === 'S') {
        vlrServicos = vlrServicos + parseFloat(listaProdutos[x].mi_vlr_total);
      } else if (listaProdutos[x].tipoItem === 'P') {
        vlrProdutos = vlrProdutos + parseFloat(listaProdutos[x].mi_vlr_total);
      } else if (listaProdutos[x].tipoItem === 'A') {
        vlrAvulsos = vlrAvulsos + parseFloat(listaProdutos[x].mi_vlr_total);
      }
    };

    vlrServicos = parseFloat(vlrServicos.toFixed(2));
    vlrProdutos = parseFloat(vlrProdutos.toFixed(2));
    vlrAvulsos = parseFloat(vlrAvulsos.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.os_vlr_servicos = vlrServicos;
    registro.os_vlr_produtos = vlrProdutos;
    registro.os_vlr_avulsos = vlrAvulsos;
    registro.os_vlr_total = vlrTotal;

    this.setState({
      registro,
    });
  }

  onChangeCliente = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });

    this.buscaCondPagtos(event.target.value.key);
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['os_cliente'] = event.os_cliente;
    this.setState(event);
    this.buscaVeiculos(event.os_cliente.key);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['os_usuario'] = event.os_usuario;
    this.setState(event);
  }

  onDateEmissaoChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['os_data_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ os_data_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDateIniChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['os_data_ini'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ os_data_ini: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDateFimChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['os_data_fim'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ os_data_fim: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }


  buscaVeiculos = (cliente) => {
    // console.log('buscaVeiculos: ', cliente);
    this.setState({ codVeiculosSelect: [], descVeiculosSelect: [] });
    return axios.get('/pessoas/buscaVeiculos', {
      params: {
        pessoa: cliente,
      }
    }).then(response => {
      const { data } = response;
      const codVeiculosSelect = data.map(veic => veic.veic_idf);
      const descVeiculosSelect = data.map(veic => veic.veic_descricao);
      // console.log('buscaVeiculos: ', codVeiculosSelect);
      // console.log('buscaVeiculos: ', descVeiculosSelect);
      this.setState({
        codVeiculosSelect,
        descVeiculosSelect,
      })
    }).catch(error => {
      console.error(error.response);
    })
  }


  onChangeVeiculo = (value) => {
    // console.log('onChangeVeiculo: ', value);
    const { registro } = this.state;
    registro['os_veiculo'] = 0;
    registro['veic_descricao'] = value;
    this.setState({
      os_veiculo: 0,
      veic_descricao: value,
    });
  }

  onSelectVeiculo = (value) => {
    // console.log('onSelectVeiculo: ', value);
    const { registro } = this.state;
    const registroIndex = this.state.descVeiculosSelect.findIndex((x) => x === value);
    // console.log('onSelectVeiculo: ', registroIndex);
    // console.log('onSelectVeiculo: ', this.state.codVeiculosSelect[registroIndex]);
    registro['os_veiculo'] = this.state.codVeiculosSelect[registroIndex];
    registro['veic_descricao'] = value;
    this.setState({
      os_veiculo: this.state.codVeiculosSelect[registroIndex],
      veic_descricao: value,
    });
  }





  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    },
      this.calculoTotalPedido(listaProdutos)
    );
  }

  onNovoProduto = (event) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: false,
        tipoTela: 'OS',
        registro: {
          mi_seq: -1,
          mi_item: { key: '0' },
          mi_servico: { key: '0' },
          mi_item_Avulso: '',
          prod_codigo: '',
          prod_descricao: '',
          prod_cod_barras: '',
          prod_ncm: '',
          med_descricao: '',
          mi_qtde: 1,
          osia_custo_unit: 0,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
          mi_calc_estoque: 1,
          tipoItem: 'P',
        }
      }
    });
  }

  onEditarProdutosClick = (reg) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: true,
        tipoTela: 'OS',
        registro: {
          mi_item: {
            key: String(reg.mi_item) + '_' + String(reg.mi_item_tamanho) + '_' + String(reg.mi_item_cor),
            label: (reg.prod_grade ? (reg.prod_descricao + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.prod_descricao) + ' [' + reg.prod_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),
            prod_grade: reg.prod_grade,
            prod_cod_barras: reg.prod_cod_barras,
            pest_item: reg.mi_item,
            pest_tamanho: reg.mi_item_tamanho,
            pest_cor: reg.mi_item_cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },
          mi_seq: reg.mi_seq,

          mi_servico: {
            key: reg.mi_servico,
            label: reg.prod_descricao,
          },
          mi_item_Avulso: reg.prod_descricao,

          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          prod_ncm: reg.prod_ncm,
          prod_cod_barras: reg.prod_cod_barras,
          med_descricao: reg.med_descricao,
          mi_qtde: reg.mi_qtde,
          osia_custo_unit: reg.osia_custo_unit,
          mi_vlr_unit: reg.mi_vlr_unit,
          mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
          mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
          mi_perc_desc: reg.mi_perc_desc,
          mi_vlr_desc: reg.mi_vlr_desc,
          mi_vlr_total: reg.mi_vlr_total,
          mi_calc_estoque: reg.mi_calc_estoque,

          tipoItem: reg.tipoItem,
        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este Item?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }




  renderValor = (os_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(os_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderTipoItem = (tipo) => {
    return (
      <span> {tipo === 'P' ? 'Produto' : (tipo === 'S' ? 'Serviço' : 'Avulso')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };


  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };




  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.os_tipo_doc) || (this.state.registro.os_tipo_doc.key === '0') || (this.state.registro.os_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.os_cond_pagto) || (this.state.registro.os_cond_pagto.key === '0') || (this.state.registro.os_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.os_vlr_total) > 0) {
      const w_cc = this.state.usuario.par_cta_corrente_padrao;
      const w_cc_Desc = this.state.usuario.cc_descricao;
      const w_Qtde_Parc = parseInt(this.state.registro.os_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.os_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.os_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.os_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.os_vlr_total) / w_Qtde_Parc).toFixed(2);

      if (w_Parc_AVista) {
        w_Data_Parc = moment(this.state.registro.os_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.os_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.os_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.os_vlr_total)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.os_vlr_total)).toFixed(2));

          vlrDif = vlrDif * (-1);

          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);

          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }

    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.os_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.os_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['os_tipo_doc'] = event.os_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['os_cond_pagto'] = event.os_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  // ----------------------------------------------------------------



  renderAcoesCheckList = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Conforme">
          <Button type="primary" onClick={() => this.onConformeClick(registro)} icon="like" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
        </Tooltip>
        <Tooltip title="Não Conforme">
          <Button type="danger" onClick={() => this.onNaoConformeClick(registro)} icon="dislike" />
        </Tooltip>
        <Tooltip title="Não se Aplica">
          <Button type="ghost" onClick={() => this.onNaoAplicaClick(registro)} icon="close" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  buscaCheckList = (value) => {
    this.setState({ OPCOES_COMBO_CHECKLIST: [] })
    axios.get('/checklist/lista').
      then(response => {
        const { data } = response;
        const OPCOES_COMBO_CHECKLIST = data.map(regList => {
          return {
            key: regList.clos_idf,
            label: regList.clos_descricao
          }
        });

        this.setState({
          OPCOES_COMBO_CHECKLIST,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }

  buscaCheckListCompleta = () => {
    // console.log('buscaCheckListCompleta: ');
    this.setState({ listaCheckList: [], OPCOES_COMBO_CHECKLIST: [] });
    return axios.get('/checklist/lista')
      .then(response => {
        const { data } = response;
        // console.log('buscaCheckListCompleta: ', response);
        if (this.state.usuario.par_checklist_completo) {
          const listaCheckList = data.map(regList => {
            return {
              clos_idf: regList.clos_idf,
              clos_descricao: regList.clos_descricao,
              check: '',
              obs: '',
            }
          });
          this.setState({
            listaCheckList,
          })
        } else {
          const OPCOES_COMBO_CHECKLIST = data.map(regList => {
            return {
              key: regList.clos_idf,
              label: regList.clos_descricao
            }
          });
          this.setState({
            OPCOES_COMBO_CHECKLIST,
          })
        }
      }).catch(error => {
        console.error(error.response);
      })
  }

  onConformeClick = (reg) => {
    // console.log('onConformeClick: ', reg);
    const listaCheckList = [...this.state.listaCheckList];
    const index = listaCheckList.findIndex(registro => registro.clos_idf === reg.clos_idf);
    listaCheckList[index] = {
      clos_idf: reg.clos_idf,
      clos_descricao: reg.clos_descricao,
      check: 'CO',
      obs: '',
    };
    this.setState({
      listaCheckList,
    });
  }

  onNaoConformeClick = (reg) => {
    // console.log('onNaoConformeClick: ', reg);
    const listaCheckList = [...this.state.listaCheckList];
    const index = listaCheckList.findIndex(registro => registro.clos_idf === reg.clos_idf);
    listaCheckList[index] = {
      clos_idf: reg.clos_idf,
      clos_descricao: reg.clos_descricao,
      check: 'NC',
      obs: '',
    };
    this.setState({
      listaCheckList,
    });
  }

  onNaoAplicaClick = (reg) => {
    // console.log('onNaoAplicaClick: ', reg);
    const listaCheckList = [...this.state.listaCheckList];
    const index = listaCheckList.findIndex(registro => registro.clos_idf === reg.clos_idf);
    listaCheckList[index] = {
      clos_idf: reg.clos_idf,
      clos_descricao: reg.clos_descricao,
      check: 'NA',
      obs: '',
    };
    this.setState({
      listaCheckList,
    });
  }

  renderCheck = (tipo) => {
    return (
      <span style={{ color: tipo === 'CO' ? '#04B404' : (tipo === 'NC' ? '#FF0000' : '#FFBF00') }}> {tipo === 'CO' ? 'CONFORME' : tipo === 'NC' ? 'NÃO CONFORME' : tipo === 'NA' ? 'NÃO SE APLICA' : ''} </span>
    );
  };

  renderOBS = (obs, registro) => {
    // console.log('renderOBS: ', registro);
    if ((registro.check === 'NC') && (!this.state.registro.os_idf)) {
      return (
        <Col xs={24} style={{ marginTop: -12, marginBottom: -30, marginLeft: -10, marginRight: -10 }}>
          <Input
            size="small"
            onChange={(value) => {
              // console.log('renderOBS1: ', value.target.value);
              registro['obs'] = value.target.value;
            }}
          />
        </Col>
      )
    } else {
      return (
        <span> {registro.obs} </span>
      )
    }
  };




  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { usuario, carregandoForm, listaProdutos, listaParcelas, listaCheckList, produtoSelecionado, OPCOES_COMBO_CHECKLIST, descVeiculosSelect,
      vlrDifParc, vlrTotalParc, caixaFechado, modalListaVisible, modalParcelaVisible, modalProdutoVisible, modalEmissaoNFeVisible, registroNfe } = this.state;

    const { os_idf, os_numero, os_situacao, os_data_emissao, os_cliente, os_obs, os_cond_pagto, os_tipo_doc,
      os_qtde_itens, os_usuario, os_descricao, os_solicitante, veic_descricao,
      os_vlr_total, os_vlr_servicos, os_vlr_produtos, os_vlr_avulsos, os_data_ini, os_data_fim,
      oso_defeitos, oso_laudo, checkListSelect, os_emitir_nfe, os_emitir_nfse } = this.state.registro;

    // console.log('OrdemServicoForm.this.state: ', this.state);

    return (
      <Modal
        title={os_idf ? (this.state.visualizando ? "Ordem de Serviço" : "Edição de Ordem de Serviço") : "Inclusão de Ordem de Serviço"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={'clientes'}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <VendaItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          produtoSelecionado={produtoSelecionado}
        />

        <NotaFiscalEmissaoComplForm
          visivel={modalEmissaoNFeVisible}
          onSalvarEmissaoNfeClick={this.onSalvarEmissaoNfeClick}
          onFecharModalEmissaoNFeClick={this.onFecharModalEmissaoNFeClick}
          registroNfe={registroNfe}
          listaProdutos={listaProdutos}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={os_vlr_total}
          condPagto={os_cond_pagto}
        />

        <SpinnerForm visivel={carregando} texto={'Salvando. Aguarde...'} />

        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <Col xs={24} sm={4} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="os_numero"
                        ref="os_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={os_numero}
                        readOnly
                      />
                    </Col>
                    <Col xs={24} sm={8} style={{ marginTop: 4 }} className="camposEspacoDireita">
                      <span>Data Emissão *</span>
                      <DatePicker
                        onChange={this.onDateEmissaoChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(os_data_emissao, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={12}>
                      <span>Situação</span>
                      <InputForm
                        type="select"
                        id="os_situacao"
                        ref="os_situacao"
                        value={os_situacao}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_SIT}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={10} style={{ marginTop: -20 }}>
                      <PessoaFrame
                        label="Cliente *"
                        id="os_cliente"
                        value={os_cliente}
                        tipo="C"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        disabled={caixaFechado}
                        descricaoPrimeiroItem="Selecione um Cliente"
                      />
                    </Col>
                    <Col xs={24} sm={2} style={{ marginTop: 4, paddingRight: 20 }}>
                      <Tooltip title="Cadastro de Clientes" placement="topLeft">
                        <Button
                          type="dashed"
                          icon="plus"
                          htmlType="button"
                          onClick={() => this.onCadPessoaClick()}
                        />
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={usuario && parseInt(usuario.par_cliente) !== parseInt(os_cliente.key) && usuario.par_veiculos_clientes ? 6 : 12} style={{ marginTop: -20 }}>
                      <span>Solicitante</span>
                      <InputForm
                        id="os_solicitante"
                        ref="os_solicitante"
                        value={os_solicitante}
                        maxLength={50}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                    {usuario && parseInt(usuario.par_cliente) !== parseInt(os_cliente.key) && usuario.par_veiculos_clientes ? (
                      <Col xs={24} sm={6} style={{ marginTop: -16, paddingLeft: 20 }}>
                        <span>Veículo do Cliente</span>
                        <AutoComplete
                          id="veic_descricao"
                          ref="veic_descricao"
                          value={veic_descricao}
                          style={{ width: "100%" }}
                          dataSource={descVeiculosSelect}
                          onSelect={this.onSelectVeiculo}
                          onSearch={this.onChangeVeiculo}
                          filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                        />
                      </Col>
                    ) : null}
                    <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Descrição *</span>
                      <InputForm
                        id="os_descricao"
                        ref="os_descricao"
                        value={os_descricao}
                        maxLength={100}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                    <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                      <UsuarioFrame
                        label="Vendedor *"
                        id="os_usuario"
                        value={os_usuario}
                        width={"100%"}
                        vendedor={1}
                        onChange={this.onChangeVendedor}
                        descricaoPrimeiroItem="Selecione um Vendedor"
                      />
                    </Col>
                    <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Data Início</span>
                      <DatePicker
                        onChange={this.onDateIniChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(os_data_ini, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                      <span>Data Entrega</span>
                      <DatePicker
                        onChange={this.onDateFimChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(os_data_fim, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8, paddingRight: 20 }}>
                      <span>Total Serviços</span>
                      <InputForm
                        type="number"
                        id="os_vlr_servicos"
                        ref="os_vlr_servicos"
                        value={os_vlr_servicos}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8, paddingRight: 20 }}>
                      <span>Total Produtos</span>
                      <InputForm
                        type="number"
                        id="os_vlr_produtos"
                        ref="os_vlr_produtos"
                        value={os_vlr_produtos}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8, paddingRight: 20 }}>
                      <span>Total Avulsos</span>
                      <InputForm
                        type="number"
                        id="os_vlr_avulsos"
                        ref="os_vlr_avulsos"
                        value={os_vlr_avulsos}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8 }}>
                      <span>Valor Total O.S</span>
                      <InputForm
                        type="number"
                        id="os_vlr_total"
                        ref="os_vlr_total"
                        value={os_vlr_total}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>

                    {OPCOES_COMBO_CHECKLIST && OPCOES_COMBO_CHECKLIST.length > 0 ? (
                      <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                        <span>CheckList</span>
                        <InputForm
                          type="select"
                          id="checkListSelect"
                          ref="checkListSelect"
                          value={checkListSelect}
                          placeholder="Check List da O.S."
                          onChange={this.onChange}
                          data={OPCOES_COMBO_CHECKLIST}
                          multiple
                        />
                      </Col>
                    ) : null}

                    {usuario && (usuario.emissorNFe || usuario.emissorNFCe) ? (
                      <div>
                        {
                          (!this.state.registro.nf_idf_nfe || this.state.registro.nf_status_nfe !== 1) && (this.state.registro.nf_modelo_nfe === null || this.state.registro.nf_modelo_nfe === 55 || this.state.registro.nf_modelo_nfe === 65) ? (
                            <Col xs={24} sm={6}>
                              <InputForm
                                type="checkbox"
                                id="os_emitir_nfe"
                                ref="os_emitir_nfe"
                                onChange={this.onChange}
                                value={os_emitir_nfe ? true : false}
                              >
                                Emitir Nota Produto - NFe
                              </InputForm>
                            </Col>
                          ) : this.state.registro.nf_idf_nfe && this.state.registro.nf_status_nfe === 1 && (this.state.registro.nf_modelo_nfe === 55 || this.state.registro.nf_modelo_nfe === 65) ? (
                            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                              <span>Nota de Produto - NFe</span>
                              <InputForm
                                id="nf_numero_nfe"
                                ref="nf_numero_nfe"
                                maxLength={9}
                                onChange={this.onChange}
                                value={this.state.registro.nf_numero_nfe}
                                readOnly
                              />
                            </Col>
                          ) : null
                        }
                      </div>
                    ) : null}

                    {usuario && usuario.emissorNFSe ? (
                      <div>
                        {
                          !this.state.registro.nf_idf_nfse || this.state.registro.nf_status_nfse !== 1 && this.state.registro.nf_modelo_nfse === 99 ? (
                            <Col xs={24} sm={6}>
                              <InputForm
                                type="checkbox"
                                id="os_emitir_nfse"
                                ref="os_emitir_nfse"
                                onChange={this.onChange}
                                value={os_emitir_nfse ? true : false}
                              >
                                Emitir Nota de Serviço - NFSe
                              </InputForm>
                            </Col>
                          ) : this.state.registro.nf_idf_nfse && this.state.registro.nf_status_nfse === 1 && this.state.registro.nf_modelo_nfse === 99 ? (
                            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                              <span>Nota de Serviço - NFSe</span>
                              <InputForm
                                id="nf_numero_nfse"
                                ref="nf_numero_nfse"
                                maxLength={9}
                                onChange={this.onChange}
                                value={this.state.registro.nf_numero_nfse}
                                readOnly
                              />
                            </Col>
                          ) : null
                        }
                      </div>
                    ) : null}

                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Itens da O.S" key="produtos">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{ marginTop: -60 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProduto}
                      icon="plus"
                      className="btn-primary"
                    > Novo Item
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  pagination={false}
                  scroll={{ y: 245 }}
                  rowKey={(listaProdutos => listaProdutos.mi_item + '_' + listaProdutos.mi_item_tamanho + '_' + listaProdutos.mi_item_cor)}
                >
                  <Column
                    key="tipoItem"
                    dataIndex="tipoItem"
                    title="Tipo Item"
                    width={60}
                    align="center"
                    className="listaCadastro"
                    render={this.renderTipoItem}
                  />
                  <Column
                    key="foto_produto"
                    title="Foto"
                    width={70}
                    align="center"
                    className="listaCadastro"
                    render={(text, registro) => (
                      <ItemFotoProduto
                        produtoId={registro.prod_idf || registro.mi_item}
                        prodImagem={registro.prod_imagem}
                        prodEmpresa={registro.prod_empresa}
                        tamanho={44}
                        alt={registro.prod_descricao}
                      />
                    )}
                  />
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="mi_qtde"
                    dataIndex="mi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_unit"
                    dataIndex="mi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_desc"
                    dataIndex="mi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_total"
                    dataIndex="mi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  {this.state.visualizar || caixaFechado || (this.state.registro.nf_idf && ((this.state.registro.nf_status === 1) || (this.state.registro.nf_status === 4) || (this.state.registro.nf_status === 5))) ? null :
                    (<Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutos}
                      width={70}
                      align="center"
                      className="listaCadastro"
                    />
                    )}
                </Table>
              </div>
            </TabPane>


            <TabPane tab="Histórico" key="historico">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{}}>
                    <span>Defeitos Relatados</span>
                    <InputForm
                      id="oso_defeitos"
                      ref="oso_defeitos"
                      value={oso_defeitos}
                      type="textarea"
                      rows={6}
                      maxLength={9500}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                  <Col xs={24} style={{ marginTop: -10 }}>
                    <span>Laudo Técnico</span>
                    <InputForm
                      id="oso_laudo"
                      ref="oso_laudo"
                      value={oso_laudo}
                      type="textarea"
                      rows={6}
                      maxLength={9500}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                </Row>

              </div>
            </TabPane>



            {usuario && usuario.par_checklist_completo ? (
              <TabPane tab="Check-List" key="checklist">
                <div style={{ height: 350 }}>
                  <Table
                    loading={{
                      spinning: carregandoForm,
                      tip: 'Carregando. Aguarde...',
                      size: "large"
                    }}
                    dataSource={listaCheckList}
                    pagination={false}
                    scroll={{ y: 245 }}
                    rowKey={(listaCheckList => listaCheckList.clos_idf)}
                  >
                    <Column
                      key="clos_descricao"
                      dataIndex="clos_descricao"
                      title="Itens do Check List"
                      width={"40%"}
                      align="left"
                      className="listaCadastro"
                    />
                    <Column
                      key="check"
                      dataIndex="check"
                      title="Checagem"
                      width={"15%"}
                      align="center"
                      render={this.renderCheck}
                      className="listaCadastro"
                    />
                    <Column
                      key="obs"
                      dataIndex="obs"
                      title="Observação"
                      width={"20%"}
                      align="left"
                      render={this.renderOBS}
                      className="listaCadastro"
                    />
                    <Column
                      key="acoes"
                      title=""
                      render={this.state.registro.os_idf ? '' : this.renderAcoesCheckList}
                      width={"25%"}
                      align="center"
                      className="listaCadastro"
                    />
                  </Table>
                </div>
              </TabPane>
            ) : null}




            <TabPane tab="Forma Pagamento" key="formaPagto">
              <div style={{ height: 350 }}>

                <Row>
                  {this.state.visualizando || caixaFechado ? null : (
                    <Row>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }} className="camposEspacoDireita">
                        <TipoDocFrame
                          label="Tipo Documento"
                          id="os_tipo_doc"
                          value={os_tipo_doc}
                          width={"100%"}
                          onChange={this.onChangeTipoDoc}
                          descricaoPrimeiroItem="Informe o Tipo de Documento"
                        />
                      </Col>
                      <Col xs={24} sm={10} style={{ marginTop: -5 }}>
                        <CondPagtoFrame
                          label="Condição de Pagamento"
                          id="os_cond_pagto"
                          value={os_cond_pagto}
                          width={"100%"}
                          onChange={this.onChangeCondPagto}
                          descricaoPrimeiroItem="Informe a Condição de Pagamento"
                        />
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.montaParcelas}
                            icon="calculator"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            icon="edit"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 14, marginLeft: 10 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            icon="close"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                      <Col xs={24}>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(os_vlr_total)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </Col>
                    </Row>
                  )}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaParcelas}
                      pagination={false}
                      scroll={{ y: 245 }}
                      rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                    >
                      <Column
                        key="tparc_parcela"
                        dataIndex="tparc_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="tparc_data_parcela"
                        dataIndex="tparc_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="tparc_valor"
                        dataIndex="tparc_valor"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="situacao_parcela"
                        dataIndex="situacao_parcela"
                        title="Situação"
                        width={80}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="td_descricao"
                        dataIndex="td_descricao"
                        title="Tipo Documento"
                        width={300}
                        align="left"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </Row>

              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar || caixaFechado || ((this.state.registro.nf_idf_nfe && ((this.state.registro.nf_status_nfe === 1) || (this.state.registro.nf_status_nfe === 4) || (this.state.registro.nf_status_nfe === 5))) && (this.state.registro.nf_idf_nfse && ((this.state.registro.nf_status_nfse === 1) || (this.state.registro.nf_status_nfse === 4) || (this.state.registro.nf_status_nfse === 5)))) ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar O.S
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrdemServicoForm.js